import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import ContactsVM from './ContactsVM';
import { observer } from 'mobx-react';
import Contact from '../../Models/Contacts/Contact';
import ContactLookup from '../../Models/Contacts/ContactLookup';
import * as Roles from "../../Models/Security/Roles";
import ContactsEditModal from './Components/ContactsEditModal';
import { ModalUtils } from '@singularsystems/neo-core';

@observer
export default class ContactsView extends Views.ViewBase<ContactsVM> {

    constructor(props: unknown) {
        super("Contacts", ContactsVM, props);
    }

    public render() {
        const canEdit = this.viewModel.authorisationService.hasRole(Roles.Contact.Edit);
        const canDelete = this.viewModel.authorisationService.hasRole(Roles.Contact.Delete);

        return (
            <div>
                <Neo.Card title="Criteria">
                    <div className="row">
                        <Neo.FormGroupInline bind={this.viewModel.criteria.meta.firstName} className="col-lg-3" />
                        <Neo.FormGroupInline bind={this.viewModel.criteria.meta.lastName} className="col-lg-3" />
                    </div>
                </Neo.Card>
                <Neo.Card title={"Contacts"}>
                    <Neo.Pager pageManager={this.viewModel.pageManager} pageControls="bottom" >
                        <NeoGrid.Grid<ContactLookup> addButton={{ onClick: () => this.viewModel.editContact(null) }}>
                            {(item, meta) => (
                                <NeoGrid.Row>
                                    <NeoGrid.Column display={meta.firstName} />
                                    <NeoGrid.Column display={meta.lastName} />
                                    <NeoGrid.Column display={meta.emailAddress} />
                                    <NeoGrid.Column display={meta.phoneNo} />
                                    <NeoGrid.ButtonColumn
                                        editButton={{ onClick: () => this.viewModel.editContact(item.contactId), disabled: !canDelete }}
                                        deleteButton={{ onClick: () => ModalUtils.showYesNoDismissible("Delete", `Are you sure you want to delete ${item}?`, 
                                            () => this.viewModel.deleteContact(item.contactId)) , disabled: !canEdit }} />
                                </NeoGrid.Row>
                            )}
                        </NeoGrid.Grid>
                    </Neo.Pager>
                </Neo.Card>
                <ContactsEditModal viewModel={this.viewModel} showContactType />
            </div>
        );
    }
}